/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Alert, Heading, HFlow, Icon, VFlow } from 'bold-ui'
import { AccordionAnimation } from 'components/accordion/AccordionAnimation'
import { AccordionButton } from 'components/accordion/AccordionButton'
import { UNIFICACAO_BASE_TEST_ENABLED } from 'config/flags'
import theme from 'config/theme'
import { usePedidoEnvioQuery } from 'graphql/hooks.generated'
import { useState } from 'react'
import { Accordion, AccordionItem, AccordionItemPanel } from 'react-accessible-accordion'

import { ButonsTesteUnificacaoBaseComponent } from './ButtonsTesteUnificacaoBaseComponent'
import { SolicitacaoEnvioForm } from './SolicitacaoEnvioForm'
import { ValidacaoSenhaForm } from './ValidacaoSenhaForm'

export interface ConfiguracaoUnificacaoBaseBoxProps {
  conexaoInternet: boolean
}

export interface EstadoCamposUnificacaoBase {
  isCampoSolicitacaoEnvioAtivo: boolean
  isCampoSenhaAtivo: boolean
  showBlocoInformativoUnificarBases: boolean
}

export const ConfiguracaoUnificacaoBaseBox = (props: ConfiguracaoUnificacaoBaseBoxProps) => {
  const [solicitacaoId, setSolicitacaoId] = useState<string>()
  const [estadoCamposForms, setEstadoCamposForms] = useState<EstadoCamposUnificacaoBase>()
  const { conexaoInternet } = props
  const { data } = usePedidoEnvioQuery({
    onCompleted: (data) => {
      setSolicitacaoId(data.pedidoEnvio?.id)
      setEstadoCamposForms({
        isCampoSolicitacaoEnvioAtivo: !data.pedidoEnvio,
        isCampoSenhaAtivo: !!data.pedidoEnvio && !data.pedidoEnvio?.chaveAutenticacao,
        showBlocoInformativoUnificarBases: !!data.pedidoEnvio?.chaveAutenticacao,
      })
    },
  })

  return (
    <VFlow>
      {!conexaoInternet && (
        <Alert type='info' inline>
          Não é possível unificar bases pois não há conexão com a internet
        </Alert>
      )}
      <Accordion allowZeroExpanded={true} css={styles.accordion}>
        <AccordionItem>
          <AccordionAnimation>
            <AccordionButton style={styles.accordionButton}>
              <HFlow alignItems='center'>
                <Icon icon='angleDown' />
                <Heading level={3}>Envio de dados para instalação municipal</Heading>
              </HFlow>
            </AccordionButton>
            <AccordionItemPanel css={styles.content}>
              <VFlow vSpacing={1}>
                <Alert type='info' inline={true}>
                  Para unificar a base é necessário solicitar a <b>chave </b> ao administrador da instalação destino. É
                  preciso ter conectividade com a internet.
                </Alert>
                <SolicitacaoEnvioForm
                  conexaoInternet={conexaoInternet}
                  solicitacaoId={solicitacaoId}
                  setSolicitacaoId={setSolicitacaoId}
                  estadoCamposForms={estadoCamposForms}
                  setEstadoCamposForms={setEstadoCamposForms}
                  data={data.pedidoEnvio}
                />
                <ValidacaoSenhaForm
                  conexaoInternet={conexaoInternet}
                  solicitacaoId={solicitacaoId}
                  estadoCamposForms={estadoCamposForms}
                  setEstadoCamposForms={setEstadoCamposForms}
                />
              </VFlow>
            </AccordionItemPanel>
          </AccordionAnimation>
        </AccordionItem>
      </Accordion>

      <Accordion allowZeroExpanded={true} css={styles.accordion}>
        <AccordionItem>
          <AccordionAnimation>
            <AccordionButton style={styles.accordionButton}>
              <HFlow alignItems='center'>
                <Icon icon='angleDown' />
                <Heading level={3}>Recebimento de dados de instalações locais</Heading>
              </HFlow>
            </AccordionButton>
          </AccordionAnimation>
        </AccordionItem>
      </Accordion>
      {UNIFICACAO_BASE_TEST_ENABLED && <ButonsTesteUnificacaoBaseComponent />}
    </VFlow>
  )
}

const styles = {
  accordion: css`
    padding: 0.5rem 1rem;
    background: ${theme.pallete.primary.c100};
    &:hover {
      background-color: ${theme.pallete.primary.c100};
    }
  `,
  content: css`
    padding: 9px;
    background: ${theme.pallete.primary.c100};
  `,
  accordionButton: css`
    &:hover {
      background-color: ${theme.pallete.primary.c100};
    }
  `,
}
